<template>
    <div
        class="training-row"
        @mouseover="changeHoverState(true)"
        @mouseleave="changeHoverState(false)"
        :class="{ hovered, selected: isSelected, multiSelectMode }"
        @click="() => onSelectChanged(row._id)"
    >
        <div class="checkbox" v-if="hovered || multiSelectMode">
            <a-checkbox
                :checked="isSelected"
                @change="(e) => onSelectChanged(row._id)"
                @click="() => onSelectChanged(row._id)"
            />
        </div>
        <div class="quote" v-else>
            <span class="material-icons"> format_quote </span>
        </div>
        <div class="phrase">
            <span v-tippy="{ followCursor: true, placement: 'top-center' }" :content="row.text">{{ row.text }}</span>
            <a
                href=""
                v-if="row.conversation && hovered && !multiSelectMode && row.conversation"
                @click="(e) => gotoArchive(e, row)"
                >( {{ $t("chatbotv2.goToChat") }})</a
            >
        </div>
        <div class="date" v-if="!hovered || multiSelectMode">{{ timeHumanized() }}</div>
        <div class="unmatched" v-if="!hovered || multiSelectMode">
            <div class="unmatched-value">
                {{ row.unmatched }}
            </div>
        </div>
        <div class="actions" v-if="hovered && !multiSelectMode">
            <div
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                content="AiTrain"
                @click="() => (aiFaqModalVisible = true)"
            >
                <span class="material-icons"> smart_toy </span>
            </div>
            <a-popover
                :visible="trainFormVisible"
                :overlayClassName="'no-padding'"
                placement="bottom"
                @visibleChange="(isVisible) => (trainFormVisible = isVisible)"
                trigger="click"
            >
                <div slot="content">
                    <TrainForm
                        :all-stories="stories"
                        :default-selected-story-id="row.story"
                        :on-cancel="() => (trainFormVisible = false)"
                        :on-train="startTrain"
                    />
                </div>
                <div v-tippy="{ followCursor: true, placement: 'bottom-end' }" content="Train" @click="toggleTrainForm">
                    <span class="material-icons"> done </span>
                </div>
            </a-popover>

            <div v-tippy="{ followCursor: true, placement: 'bottom-end' }" content="Ignore" @click="ignoreItem">
                <span class="material-icons"> visibility_off </span>
            </div>
            <div
                class=""
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                :content="$t('message.delete')"
                @click="deleteItem"
            >
                <span class="material-icons"> close </span>
            </div>
        </div>
        <Modal2
            v-if="aiFaqModalVisible"
            @cancel="() => (aiFaqModalVisible = false)"
            :className="'ai-destroy-modal'"
            :showFooter="false"
            :showTitle="false"
        >
            <AIKnowledgeCreateForm
                :title="'Question'"
                :description="'Answer'"
                :question-item="[{ text: row.text }]"
                @faqCreated="faqCreated"
            />
        </Modal2>
    </div>
</template>

<script>
import log2 from "../../../../../utils/log2";
import moment from "moment";
import TrainForm from "./TrainForm";
import Modal2 from "../../../../../components/common/Modal2.vue";
import AIKnowledgeCreateForm from "../../ai/files/AIKnowledgeCreateForm.vue";

const log = log2("QueryRowItem");
export default {
    name: "QueryRowItem",
    components: { TrainForm, Modal2, AIKnowledgeCreateForm },
    props: {
        row: {
            type: Object,
            required: false,
            default: () => ({
                siteId: "",
                conversation: "",
                story: "",
                storyVersion: "",
                createdDate: Date.now(),
                text: "mesut deneme",
                unmatched: 17,
                ignore: false,
            }),
        },
        isSelected: {
            type: Boolean,
            required: false,
            default: false,
        },
        onSelectChanged: {
            type: Function,
            required: false,
            default: () => {},
        },
        multiSelectMode: {
            type: Boolean,
        },
        onDeleted: {
            type: Function,
        },
        onIgnored: {
            type: Function,
        },
        onTrained: {
            type: Function,
        },
        stories: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            hovered: false,
            trainFormVisible: false,
            aiFaqModalVisible: false,
        };
    },
    methods: {
        gotoArchive(e, row) {
            e.preventDefault();
            e.stopPropagation();
            if (row.conversation) {
                const conversationId = _.get(row.conversation, "_id", row.conversation);
                this.$router.push(
                    `/archives/?allTime=1&skipCount=0&limit=20&selectedChatId=${conversationId}&query=${conversationId}`
                );
            }
        },
        startTrain(storyId, storyVersion, blockId) {
            this.trainFormVisible = true;
            this.hovered = false;
            this.onTrained(this.row._id, storyId, storyVersion, blockId);
            this.$emit("trained");
        },
        timeHumanized() {
            return moment(this.row.createdAt).calendar();
        },
        deleteItem(e) {
            e.stopPropagation();
            this.onDeleted(this.row._id);
        },
        ignoreItem(e) {
            e.stopPropagation();
            this.onIgnored(this.row._id);
        },
        toggleTrainForm(e) {
            e.stopPropagation();
        },
        changeHoverState(hovered) {
            if (this.trainFormVisible) return;
            this.hovered = hovered;
        },
        faqCreated() {
            this.aiFaqModalVisible = false;
            this.onDeleted(this.row._id);
        },
    },
    watch: {
        trainFormVisible(newVal) {
            if (!newVal) {
                this.hovered = false;
            }
        },
    },
};
</script>

<style lang="scss">
.training-row {
    .checkbox {
        align-items: center;
        display: flex;
        height: 47px;
        justify-content: center;
    }

    .quote {
        display: flex;
        justify-content: center;
        line-height: 47px;

        .material-icons {
            color: #c6cdd4;
            font-size: 20px;
        }
    }

    .phrase {
        align-items: center;
        color: #22272d;
        display: flex;
        line-height: 47px;
        padding-right: 10px;

        span {
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        a {
            color: #006cff;
            cursor: pointer;
            flex-shrink: 0;
            padding-left: 10px;
            transition: all 0.3s;
            text-decoration: none;
        }
    }

    .date {
        color: #516173;
        font-size: 12px;
        //line-height: 47px;
    }

    .unmatched {
        display: flex;
        justify-content: center;

        .unmatched-value {
            background: #e3ebf4;
            border-radius: 15px;
            color: #516173;
            font-size: 14px;
            line-height: 18px;
            padding: 3px 10px;
        }
    }

    .actions {
        align-items: center;
        display: flex;
        justify-content: center;

        div {
            border: 1px solid #006cff;
            border-radius: 100%;
            cursor: pointer;
            height: 26px;
            margin: 0 5px;
            transition: opacity 0.3s;
            width: 26px;
            align-items: center;
            display: flex;
            justify-content: center;

            .material-icons {
                color: #006cff;
                font-size: 15px;
            }
        }
    }
}

.ai-destroy-modal {
    width: 900px !important;

    .ant-modal {
        margin-left: 17% !important;
    }

    .ant-modal-content {
        width: 1000px !important;
    }

    .custom-modal-body {
        padding: 0;
        background: #f5f5f5 !important;
    }
}
</style>
